import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _excluded = ["linkAs", "style", "type", "color", "kind", "size", "iconLeft", "iconRight", "width", "isDisabled", "isLoading", "isDropdown", "isRound", "isSelected", "children", "className", "overwrites"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import pt from 'prop-types';
import { Flex, FlexItem, Link, Icon, BreakpointContext, breakpointPropSwitch, Element } from '../';
import { appendHtmlClass, extendProps, responsivePropType, getOverwrites } from '../../js/util';
import getConfig from '../../js/settings';
import './_index.scss';
var BUTTON_KIND = getConfig('BUTTON_KIND');
var BUTTON_KIND_PREFIX = getConfig('BUTTON_KIND_PREFIX');
var BUTTON_KIND_DEFAULT = getConfig('BUTTON_KIND_DEFAULT');
var BUTTON_COLOR = getConfig('BUTTON_COLOR');
var BUTTON_COLOR_PREFIX = getConfig('BUTTON_COLOR_PREFIX');
var BUTTON_COLOR_DEFAULT = getConfig('BUTTON_COLOR_DEFAULT');
var BUTTON_SIZE = getConfig('BUTTON_SIZE');
var BUTTON_SIZE_PREFIX = getConfig('BUTTON_SIZE_PREFIX');
var BUTTON_SIZE_DEFAULT = getConfig('BUTTON_SIZE_DEFAULT');
var BUTTON_WIDTH = getConfig('BUTTON_WIDTH');
var BUTTON_WIDTH_DEFAULT = getConfig('BUTTON_WIDTH_DEFAULT');
var BUTTON_WIDTH_PREFIX = getConfig('BUTTON_WIDTH_PREFIX');
var ICON_SPINNER = getConfig('ICON_SPINNER');
var ICON_DROPDOWN = getConfig('ICON_DROPDOWN');
var Button = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Button, _React$Component);
  function Button() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.DEFAULT_CLASS = 'button';
    return _this;
  }
  var _proto = Button.prototype;
  _proto.getResponsiveValue = function getResponsiveValue(options) {
    return breakpointPropSwitch(options, this.context);
  };
  _proto.getColorClass = function getColorClass(color) {
    return color && color !== BUTTON_COLOR_DEFAULT ? "" + BUTTON_COLOR_PREFIX + color : null;
  };
  _proto.getKindClass = function getKindClass(kind) {
    return kind && kind !== BUTTON_KIND_DEFAULT ? "" + BUTTON_KIND_PREFIX + kind : null;
  };
  _proto.getSizeClass = function getSizeClass(size) {
    if (!size) return null;
    return size !== BUTTON_SIZE_DEFAULT ? "" + BUTTON_SIZE_PREFIX + size : null;
  };
  _proto.getWidthClass = function getWidthClass(width) {
    if (!width) return null;
    return BUTTON_WIDTH.hasOwnProperty(width) && width !== BUTTON_WIDTH_DEFAULT ? "" + BUTTON_WIDTH_PREFIX + width : BUTTON_WIDTH_PREFIX + "custom";
  };
  _proto.getClass = function getClass(className, color, kind, size, width, isDisabled, isLoading, isDropdown, isRound, isSelected) {
    var classes = [this.DEFAULT_CLASS, this.getColorClass(color), this.getKindClass(kind), this.getSizeClass(size), this.getWidthClass(width)];
    if (isDisabled) classes.push('disabled');
    if (isLoading) classes.push('loading');
    if (isDropdown) classes.push('dropdown');
    if (isRound) classes.push('round');
    if (isSelected) classes.push('selected');
    classes.forEach(function (i) {
      className = appendHtmlClass(className, i);
    });
    return className;
  };
  _proto.getIcon = function getIcon(name, size, className, spin) {
    if (className === void 0) {
      className = null;
    }
    if (spin === void 0) {
      spin = false;
    }
    if (!size) size = BUTTON_SIZE_DEFAULT;
    var iconSize = BUTTON_SIZE[size].icon;
    return /*#__PURE__*/React.createElement(Icon, {
      name: name,
      spin: spin,
      size: iconSize,
      className: className,
      display: "iblock"
    });
  };
  _proto.render = function render() {
    var _this$props = this.props,
      linkAs = _this$props.linkAs,
      style = _this$props.style,
      type = _this$props.type,
      color = _this$props.color,
      kind = _this$props.kind,
      size = _this$props.size,
      iconLeft = _this$props.iconLeft,
      iconRight = _this$props.iconRight,
      width = _this$props.width,
      isDisabled = _this$props.isDisabled,
      isLoading = _this$props.isLoading,
      isDropdown = _this$props.isDropdown,
      isRound = _this$props.isRound,
      isSelected = _this$props.isSelected,
      children = _this$props.children,
      className = _this$props.className,
      overwrites = _this$props.overwrites,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var flexOverwrites = getOverwrites(overwrites, 'Flex');
    var Component = linkAs;
    var buttonProps = {};
    var buttonStyle = typeof style === 'object' ? _objectSpread({}, style) : {};
    if (type === 'link') {
      type = 'raw';
    } else {
      Component = Element;
      buttonProps['as'] = 'button';
      if (isDisabled || isLoading) rest.disabled = true;
    }
    if (size) {
      size = this.getResponsiveValue(size);
    }
    if (width) {
      width = this.getResponsiveValue(width);
      if (!BUTTON_WIDTH.hasOwnProperty(width)) {
        buttonStyle.width = width;
      }
    }
    var contentFlex = '0 1 auto';
    if (isDropdown) {
      iconRight = ICON_DROPDOWN;
      contentFlex = '1 1 auto';
    }
    iconLeft = iconLeft ? this.getIcon(iconLeft, size, 'icon-left') : null;
    iconRight = iconRight ? this.getIcon(iconRight, size, 'icon-right') : null;
    var iconLoad = isLoading ? this.getIcon(ICON_SPINNER, size, 'icon-load', true) : null;
    className = this.getClass(className, color, kind, size, width, isDisabled, isLoading, isDropdown, isRound, isSelected);
    buttonProps = Object.assign(buttonProps, {
      className: className,
      style: buttonStyle,
      type: type
    }, rest);
    return /*#__PURE__*/React.createElement(Component, buttonProps, /*#__PURE__*/React.createElement(Flex, Object.assign({
      alignItemsY: "center",
      alignItemsX: "center"
    }, flexOverwrites), iconLeft, width !== 'square' && /*#__PURE__*/React.createElement(FlexItem, {
      className: "button-content",
      flex: contentFlex,
      mask: "xy"
    }, children), width !== 'square' && iconRight), iconLoad);
  };
  return Button;
}(React.Component);
Button.contextType = BreakpointContext;
Object.assign(Button, extendProps(Element, ['className', 'id', 'children', 'style', 'isAnimated'], {
  /**
   *  Overwrites default link element type (Link)
   * */
  linkAs: pt.elementType,
  type: pt.oneOf(['link', 'reset', 'submit', 'button']),
  color: pt.oneOf(Object.keys(BUTTON_COLOR)),
  /**
   * Visual style of the button
   */
  kind: pt.oneOf(Object.keys(BUTTON_KIND)),
  /**
   * Button size e.g. 's'. Can be responsive e.g. ```{ 's': 'm', 'l': 'l' }```
   */
  size: responsivePropType.bind(this, pt.oneOf(Object.keys(BUTTON_SIZE))),
  iconLeft: pt.oneOfType([pt.string, pt.arrayOf(pt.string)]),
  /**
   * Right icon. In case ```isDropdown``` prop is true, this icon is pre-populated with default one
   */
  iconRight: pt.oneOfType([pt.string, pt.arrayOf(pt.string)]),
  /**
   * Width specified as: 'normal' (depending on content), 'square' (fixed width and height), 'stretch' (full width of container) or custom CSS value e.g. '10%'. Can be responsive e.g. ```{ s: 'normal', l: 'stretch' }```
   */
  width: responsivePropType.bind(this, pt.string),
  isDisabled: pt.bool,
  isLoading: pt.bool,
  /**
   * Aligned to left button indicating dropdown menu
   */
  isDropdown: pt.bool,
  /**
   * Should be used primarily in combination with width = 'square' to produce round button
   */
  isRound: pt.bool,
  /**
   * Button can be selected while being placed inside ButtonBar component
   */
  isSelected: pt.bool,
  overwrites: pt.shape({
    Flex: pt.object
  })
}, {
  type: 'button',
  kind: 'normal',
  isDisabled: false,
  isLoading: false,
  isDropdown: false,
  isRound: false,
  linkAs: Link
}));
export default Button;